import { venueUpdateVenue } from '../../graphql/mutations';
import { executeGql } from '../../utils/gql-utils';

// Removing the parent link (masterVenueID: null) disconnects the venue from the master account
export const venueDisconnectVenueApi = async (id: string): Promise<void> => {
  await executeGql(venueUpdateVenue, { input: { id, masterVenueID: null } });
};
